import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import floor from 'lodash/floor';

import StaticSearch from 'Components/StaticSearch/StaticSearch';
import { currencyCode } from 'Helpers/Geo/data';
import { fetchGamesUnder } from 'Redux/ducks/algolia-calls';
import pricing from 'Components/StaticSearch/games-under-pricing';
import globalMessages from 'Components/FacetSearch/LanguagesStrings';

const messages = defineMessages({
  title: {
    id: 'games-under.title',
    defaultMessage: 'Games Under {priceTag}',
  },
  fullTitle: {
    id: 'games-under.seotitle',
    defaultMessage: 'Games Under {priceTag}',
  },
});

export default function GamesUnder({
  match: { params: { price } },
  intl: { formatMessage, formatNumber },
}) {
  const convertedPrices = pricing[price];
  const convertedPriceMin = convertedPrices.min[currencyCode];
  const convertedPriceMax = convertedPrices.max[currencyCode];

  const priceTag = formatNumber(floor(convertedPriceMax / 100, 2), { minimumFractionDigits: 0, style: 'currency', currency: currencyCode });

  const priceFilter = `price.${currencyCode} > ${convertedPriceMin / 100} AND price.${currencyCode} < ${convertedPriceMax / 100}`;

  const formattedFullTitle = formatMessage(messages.fullTitle, { priceTag });
  const formattedTitle = formatMessage(messages.title, { priceTag });
  const formattedSeoBlurb = formatMessage(convertedPrices.strings.description, { priceTag });

  const crumbs = [
    {
      label: formatMessage(globalMessages.pcgames),
      link: '/all-games',
    },
    {
      label: formattedTitle,
      link: `/games-under/${price}`,
    },
  ];

  return (<StaticSearch
    showSortAndFilters
    updateHits={
      (page, hitsPerPage, filterType, sort) =>
        fetchGamesUnder(priceFilter, page, hitsPerPage, sort)
    }
    url={`games-under/${price}`}
    formattedFullTitle={formattedFullTitle}
    formattedTitle={formattedTitle}
    seoBlurb={formattedSeoBlurb}
    crumbs={crumbs}
    {...messages}
  />);
}

GamesUnder.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      price: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
